export const ErrorMessage = {
  'roles::get': 'Role get',
  'roles::list': 'List Role',
  'users::list': 'User List',
  'users::get': 'Get user Details',
  'globalAudit::list': 'Get global audit',
  'controllers::list': 'Controller List',
  'controllers::get': 'Get controller',
  'categories::list': 'Get category list',
  'equipments::list': 'Equipment List',
  'equipments::get': 'Get Equipment',
  'units::create': 'Create Unit',
  'units::list': 'Unit List',
  'units::get': 'Get Unit',
  'inventories::manufacturedInventories': 'Manufactured Inventory List',
  'inventories::unregisteredInventories': 'Get list of unregistered inventory',
  'inventories::registeredInventories': 'Get list of registered inventory',
  'customers::list': 'Get Customer List',
  'customers::get': 'Get Customer Details',
  'customers::unitDetails': 'Get Customer Unit Details',
  'dealers::list': 'Dealer List',
  'dealers::get': 'Get dealer Details',
};
